import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from 'ngx-alerts';
import { CustomValidator } from 'src/app/validators/custom-validator';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { OthersService } from 'src/app/shared/services/other-services/others.service';

@Component({
  selector: 'app-loan-tenure',
  templateUrl: './loan-tenure.component.html',
  styleUrls: ['./loan-tenure.component.scss'],
})
export class LoanTenureComponent implements OnInit {
  modalRef: BsModalRef;
  userForm: FormGroup;
  loading: boolean = false
  loanType: string;
  user = '/../../../assets/img/man.svg';
  User = this.authService.loggedInUserInfo();
  customers: Array<any>;
  statement: Array<any>;
  selectionKind: number;
  selectionData: Array<any>;
  modalTitle: string;
  checkedClient: {
    customerId?: number
    fktheStationLocationIdCustomer?: number
  };

  constructor(
    private authService: AuthServiceService,
    private others: OthersService,
    private alertService: AlertService,
    private modalService: BsModalService
  ) { }

  ngOnInit(): any {
    this.userForm = this.createFormGroup();
  }

  createFormGroup(): FormGroup {
    return new FormGroup({
      loanType: new FormControl(['', Validators.required]),
      tenure: new FormControl(
        { value: '', disabled: false },
        Validators.compose([Validators.required, CustomValidator.maxValue(100)])
      ),
      pin: new FormControl(
        { value: '', disabled: false },
        Validators.compose([
          Validators.required,
          CustomValidator.patternValidator(/\d/, { hasNumber: true }),
          Validators.maxLength(4),
          Validators.minLength(4),
        ])
      ),
    });
  }

  checkLoanType(value: string): any {
    this.others[
      value === "Boda Loan" ? "getBodaCustomersByTown" :
        value === "Taxi Loan" ? "getTaxiCustomersByTown" : "getMicroCustomersByTown"
    ](this.User.userLocationId).subscribe(
      res => {
        if (res.length > 0) {
          this.loanType = value;
          this.customers = [];
          this.customers = res;
          this.checkedClient = null;
        } else {
          this.loading = false;
          this.choosingPdts();
          this.alertService.danger({
            html: `<b>There are no ${value === "Boda Loan" ? "boda-boda" :
                value === "Taxi Loan" ? "Taxi" : "Micro loan"
              } customers registered</b>`
          });
        }
      },
      err => {
        this.loading = false
        // console.log(err);
        this.alertService.danger({
          html: '<b>' + err + '</b>'
        });
      }
    );

  }
  choosingPdts(): any {
    this.loanType = '';
  }

  getResult(res: any): void {
    this.checkedClient = res;
    this.modalRef.hide();
  }
  getClose(res: any): void {
    this.modalRef.hide();
  }

  getStatement(template: TemplateRef<string>): void {
    this.others[this.loanType === "Micro Loan" ? "microCustomerStatement" : "bodaAndTaxiCustomerStatement"]
      (this.loanType === "Micro Loan" ? this.checkedClient.customerId : {
        customerId: this.checkedClient.customerId,
        productCode: 300
      }).subscribe(
        res => {
          this.statement = res;
          this.loading = false
          if (this.statement.length === 0) {
            this.alertService.success({
              html: '<b>Customer has no previous transactions</b>'
            });
          } else this.openModal(template);
          
        },
        err => {
          this.alertService.danger({
            html: `<b> ${err}</b>`
          });
        }
      );
  }

  selectFromData(template: TemplateRef<any>, kind: number): void {
    if (kind === 100) {
      this.openModal(template);
      this.selectionKind = kind;
      this.selectionData = this.customers;
      this.modalTitle = "Select a Client";
    }
  }


  revert(): any {
    this.userForm = this.createFormGroup();
    this.checkedClient = null
  }

  refresh(): any {
    location.reload();
  }

  get fval(): any {
    return this.userForm.controls;
  }

  // modal method
  public openModal(template: TemplateRef<any>): any {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-lg modal-dialog-centered' })
    );
  }

  reduceRate(): any {
    const tenure = this.fval.tenure.value;
    if (this.userForm.valid) {
      this.loading = true
      this.others.verifyUserWithPin({ userPhone1: this.User.userPhone, userPassword: Number(this.fval.pin.value) }).subscribe(
        res => {
          if (res) {
            const data = {
              customerId: this.checkedClient.customerId,
              theStationLocationId: this.checkedClient.fktheStationLocationIdCustomer,
              productCode: this.loanType === 'Boda Loan' ? 200 : this.loanType === 'Taxi Loan' ? 300 : 400,
              theLoanTenure: tenure,
              userId: this.User.userId,
              comment: `Please set loan tenure of this customer to ${tenure} days`
            };
            this.others.setIndividualLoanTenure(data).subscribe(
              response => {
                this.loading = false
                if (response === true) {
                  this.alertService.success({
                    html: '<b> Individual Loan Tenure was Initiated Successfully, wait for approval</b>'
                  });
                  this.revert()
                }
              },
              err => {
                this.loading = false;
                this.alertService.danger({
                  html: '<b>' + err + '</b>'
                });
              }
            );
          } else {
            this.loading = false;
            this.alertService.danger({
              html: "<b> User's pin does not match<b>"
            });
          }
        },
        err => {
          this.loading = false;
          this.alertService.danger({
            html: '<b>' + err + '<b>'
          });
        }
      );
    }
  }
}
